import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Article = () => {
    const { id } = useParams();

    // 文章数据
    const articles = {
        'amazon-pet-chatbot': {
            title: 'Mastering React: Key Concepts and Essential Tips for Beginners (2025)',
            date: '2024-01-20',
            author: 'Jeff Chen',
            content: `React has taken the web development world by storm, and for good reason! 🚀 Did you know that over 40% of developers use React as their primary web framework? Whether you're a coding newbie or a seasoned dev looking to level up, mastering React is a game-changer. In this guide, we'll break down the essential concepts that'll have you building awesome web apps in no time. Ready to React-ify your skills? Let's dive in!

1. The Building Blocks: Components and JSX
At the heart of every React application lies two fundamental concepts: Components and JSX. Let's unpack these powerful tools that make React so intuitive and efficient.

Components: The LEGO Bricks of React
Imagine you're building a LEGO castle. Each brick represents a component in React. Just as you can reuse LEGO bricks to create different structures, React components are reusable pieces of code that define a part of your user interface.

Here's what makes components so awesome:

Reusability: Write once, use everywhere. Need a button? Create a Button component and use it all over your app!
Maintainability: Changes to a component automatically update everywhere it's used. Talk about efficiency!
Modularity: Break down complex UIs into manageable, bite-sized pieces. It's like dividing a big problem into smaller, solvable chunks.
In modern React, we primarily use functional components. They're just JavaScript functions that return JSX. Here's a simple example`
        },
        'walmart-hackathon': {
            title: 'walmart-hackathon',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Stock-Prediction': {
            title: 'Walmart Hackathon: 智能购物推荐系统',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Kuaishou-Technology': {
            title: 'Kuaishou-Technology',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'DiDi-Global-Inc': {
            title: 'DiDi-Global-Inc',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Amazon': {
            title: 'Amazon',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Big-Data-Analysis': {
            title: 'Big-Data-Analysis',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Applied-Machine-Learning': {
            title: 'Applied-Machine-Learning',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        },
        'Recommendation-System': {
            title: 'Recommendation-System',
            date: '2024-01-21',
            author: 'Lynn Niu',
            content: `在Walmart黑客马拉松中，我们开发了一个创新的智能购物推荐系统，旨在提升用户购物体验并优化零售效率。

1. 项目背景
   - 零售行业个性化推荐需求日益增长
   - 大规模用户数据分析的挑战
   - 实时推荐系统的性能要求

2. 技术实现
   - 特征工程
     * 用户行为数据处理
     * 商品属性特征提取
     * 时序特征构建
   - 机器学习模型
     * 协同过滤算法
     * 深度学习模型
     * 实时预测系统

3. 创新亮点
   - 多模态数据融合
   - 实时个性化推荐
   - 冷启动问题解决方案

4. 项目成果
   - 推荐准确率提升40%
   - 用户点击率提升35%
   - 获得黑客马拉松最佳创新奖

5. 技术栈
   - Python & TensorFlow
   - Feature Engineering
   - MLOps & 模型部署`
        }
    };

    const article = articles[id] || articles['walmart-hackathon'];

    return (
        <>
            <section className="article" id="article">
                <Container>
                    <Row>
                        <Col>
                            <div className="article-box">
                                <h2>{article.title}</h2>
                                <div className="article-info">
                                    <span className="date">{article.date}</span>
                                    <span className="author">Author:{article.author}</span>
                                </div>
                                <div className="article-content">
                                    {article.content.split('\n\n').map((paragraph, index) => {
                                        if (paragraph.match(/^\d+\./)) {
                                            // 处理带编号的列表
                                            const [title, ...items] = paragraph.split('\n');
                                            return (
                                                <div key={index}>
                                                    <h3>{title}</h3>
                                                    <ul>
                                                        {items.map((item, itemIndex) => (
                                                            <li key={itemIndex}>
                                                                {item.trim().startsWith('-') ? item.trim().substring(1).trim() : 
                                                                 item.trim().startsWith('*') ? item.trim().substring(1).trim() : 
                                                                 item.trim()}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            );
                                        } else {
                                            return <p key={index}>{paragraph}</p>;
                                        }
                                    })}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <footer className="article-footer footer">
                <Container>
                    <Row className="align-items-center">
                    <Col size={12} sm={6}>
                        {/* <img src={logo} alt="Logo" /> */}
                    </Col>
                    <Col size={12} sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                        <a href="https://www.linkedin.com/in/lingyu-niu/" target="_blank"><img src={navIcon1} alt="" /></a>
                            <a href="https://github.com/LynnN-98" target="_blank"><img src={navIcon2} alt="" /></a>
                            <a href="https://www.instagram.com/1ynnniu_/" target="_blank"><img src={navIcon3} alt="" /></a>
                        </div>
                        <p>Copyright 2025. All Rights Reserved</p>
                    </Col>
                    </Row>
                </Container>

            </footer>
        </>
    );
};